import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { OrganizationTreeSelect } from "@/modules/organization-cross-access/components/OrganizationTreeSelect";
import { EmptyState } from "@/shared/components/EmptyState";
import { PageHeader } from "@/shared/components/PageHeader";
import { TableToolbar } from "@/shared/components/TableToolbar";
import { useUrlParam } from "@/shared/hooks/useUrlState";
import { PlantContractTable } from "../components/PlantContractTable";
import { usePlantContractStore } from "../store/plant-contract.store";

export function PlantContractsPage() {
	// Selected org lives in the URL so back/forward restores it.
	const [orgId, setOrgId] = useUrlParam("org");
	const openCreate = usePlantContractStore((s) => s.openCreateModal);

	return (
		<div>
			<PageHeader
				title="Ekin shartnomalari"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						disabled={!orgId}
						onClick={() => orgId && openCreate(orgId)}
					>
						Shartnoma qo'shish
					</Button>
				}
			/>
			<TableToolbar
				filters={
					<div style={{ width: 260 }}>
						<OrganizationTreeSelect value={orgId} onChange={(value) => setOrgId(value || null)} />
					</div>
				}
			/>
			{orgId ? (
				<PlantContractTable organizationId={orgId} />
			) : (
				<EmptyState description="Shartnomalarni ko'rish uchun tashkilotni tanlang" />
			)}
		</div>
	);
}
